import React from 'react'
import { NavLink } from 'react-router-dom';
import { GenerateImageContext } from "../../../context/GenerateImageContext";


const NavDesktop = () => {
  const { resetImageGenerate } = React.useContext(GenerateImageContext);
  return (
    <div className="navbar-desktop">
    <ul className="list-items-navbar">
      <li>
        <NavLink onClick={() => {resetImageGenerate()}}
          to="/generate"
          className="NavLinks--Navbar"
          activeclassname="active"
        >
          Inicio
        </NavLink>
      </li>
      <li>
        <NavLink to="/gallery" className="NavLinks--Navbar" activeclassname="active" onClick={() => {resetImageGenerate()}}>
          Galería
        </NavLink>
      </li>
      <li>
        <NavLink to="/" className="NavLinks--Navbar" activeclassname="active" onClick={() => {resetImageGenerate()}}>
          Ayuda
        </NavLink>
      </li>
    </ul>
  </div>
  )
}

export default NavDesktop